import { SchedulingInsightsEvent } from 'features/scheduleBuilder/slices/schedulingInsightsEvents/types';

import { datesInRange, df, formatDate, moment } from 'util/dateTime';

const isWholeDay = (startAt: string, endAt: string): boolean => {
  const start = moment(startAt).parseZone().seconds(0);
  const end = moment(endAt).parseZone().seconds(59);
  const duration = end.diff(start, 'seconds') + 1;
  const oneDayInSeconds = 86400;
  return Math.round(duration) % oneDayInSeconds === 0;
};

export const getEvents = (dates: string[], event: SchedulingInsightsEvent) => {
  const eventStart = formatDate(
    moment(event.event_start).parseZone(),
    'parsable_reversed'
  );
  const eventEnd = formatDate(
    moment(event.event_end).parseZone(),
    'parsable_reversed'
  );

  const startTime = moment(event.event_start)
    .parseZone()
    .format(df('time_long'));
  const endTime = moment(event.event_end).parseZone().format(df('time_long'));

  const eventDates = datesInRange(eventStart, eventEnd);

  const eventDatesWithinDateRange = dates.filter(date =>
    eventDates.includes(date)
  );

  const isWholeDayEvent =
    event.event_start && event.event_end
      ? isWholeDay(event.event_start, event.event_end)
      : false;

  return eventDatesWithinDateRange.map(date => ({
    date,
    event_id: event.event_id,
    is_whole_day: isWholeDayEvent,
    title: event.title,
    event_start: startTime,
    event_end: endTime,
    address: event.address,
    predicted_attendance: event.predicted_attendance,
  }));
};
